import axios from 'axios'
import config from '../config'
import {JsonHeaders} from '../constants';

export default {
    getPmtaRelaysReport(data) {
        return axios.post(config.publicPath + 'pmta-relays-report', data, {
            headers: {
                'Content-Type': JsonHeaders
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getPmtaRelayReport(data) {
        return axios.post(config.publicPath + 'pmta-relay-report', data, {
            headers: {
                'Content-Type': JsonHeaders
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getProfitReport(data) {
        return axios.post(config.publicPath + 'profit-report', data, {
            headers: {
                'Content-Type': JsonHeaders
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getActivityReport(data) {
        return axios.post(config.publicPath + 'activity-report', data, {
            headers: {
                'Content-Type': JsonHeaders
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getProfitData(data) {
        return axios.post(config.publicPath + 'home/profit', data, {
            headers: {
                'Content-Type': JsonHeaders
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getPmtaRelayIndicatorReport(currentPage, perPage, order, filter) {
        let parameters = {
            _page: currentPage,
            itemsPerPage: perPage,
            'pmtaRelay.smtpHost': filter.smtpHost,
            'pmtaRelay.group.id': filter.relayGroupId,
            'groups[]': 'report_read',
        };
        if (filter.isVps !== null) {
            parameters['pmtaRelay.pmtaServer.isVps'] = filter.isVps;
        }
        if (typeof filter.mailProviderId === 'undefined') {
            parameters['mailProvider[exists]'] = false;
        } else {
            parameters['mailProvider.id'] = filter.mailProviderId;
        }
        parameters['order[' + order.field + ']'] = order.direction;
        return axios.get(config.publicPath + 'pmta_relay_indicators', {
            params: parameters,
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        })
    },
    getMessageReport(currentPage, perPage, order, userId, archiveStatus) {
        let parameters = {
            _page: currentPage,
            itemsPerPage: perPage,
            'user.id': userId,
            'groups[]': 'report_read',
            'report[exists]': true
        };
        if (archiveStatus !== 'all') {
            parameters['archive[exists]'] = archiveStatus;
        }
        parameters['order[' + order.field + ']'] = order.direction;
        return axios.get(config.publicPath + 'messages', {
            params: parameters,
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        })
    },
    getXlsxMessageReport(filter) {
        return axios.post(config.publicPath + 'message-report-xlsx', filter, {
            headers: {
                'Content-Type': JsonHeaders
            },
            responseType: "arraybuffer",
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getXlsxPmtaRelayIndicatorReport(filter) {
        return axios.post(config.publicPath + 'pmta-relay-indicator-report-xlsx', filter, {
            headers: {
                'Content-Type': JsonHeaders
            },
            responseType: "arraybuffer",
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getPmtaTroubleReport(data) {
        return axios.post(config.publicPath + 'pmta-trouble-report', data, {
            headers: {
                'Content-Type': JsonHeaders
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    recheckPmtaTrouble(data) {
        return axios.post(config.publicPath + 'pmta-trouble-report-recheck', data, {
            headers: {
                'Content-Type': JsonHeaders
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getMailProviderReport(data) {
        return axios.post(config.publicPath + 'mail-provider-report', data, {
            headers: {
                'Content-Type': JsonHeaders
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getEmailListReport(data) {
        return axios.post(config.publicPath + 'email-list-report', data, {
            headers: {
                'Content-Type': JsonHeaders
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getPmtaRelayDeliverabilityReport(currentPage, perPage, order, filter) {
        let parameters = {
            _page: currentPage,
            itemsPerPage: perPage,
            'pmtaRelay.smtpHost': filter.smtpHost,
            'pmtaRelay.group.id': filter.relayGroupId,
            'mailProvider.id': filter.mailServiceId,
            'groups[]': 'report_read'
        };
        parameters['order[' + order.field + ']'] = order.direction;
        return axios.get(config.publicPath + 'pmta_relay_deliverabilities', {
            params: parameters,
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        })
    },
    getPmtaRelaysMailServiceReport(data) {
        return axios.post(config.publicPath + 'pmta-relays-mail-provider-report', data, {
            headers: {
                'Content-Type': JsonHeaders
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getCampaignReport(data) {
        return axios.post(config.publicPath + 'campaign-report', data, {
            headers: {
                'Content-Type': JsonHeaders
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
}
